var _linearGradient, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 88,
    viewBox: "0 0 64 88",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 52,
    x2: 52,
    y1: 44.5,
    y2: 20
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ea2a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606361"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 88,
    maskUnits: "userSpaceOnUse",
    width: 64,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 6c0-3.31371 2.68629-6 6-6h34l24 24v58c0 3.3137-2.6863 6-6 6h-52c-3.31371 0-6-2.6863-6-6z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 6c0-3.31371 2.68629-6 6-6h52c3.3137 0 6 2.68629 6 6v76c0 3.3137-2.6863 6-6 6h-52c-3.31371 0-6-2.6863-6-6z",
    fill: "#a1a4a2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.6227 48.5241h17.8772v4h-17.8772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.6227 58.5241h17.8772v4h-17.8772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.6227 68.5241h17.8772v4h-17.8772z"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6 88c-3.31371 0-6-2.6863-6-6v-1c0 3.3137 2.68629 6 6 6h52c3.3137 0 6-2.6863 6-6v1c0 3.3137-2.6863 6-6 6z",
    fill: "#6c6d6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6 0c-3.31371 0-6 2.68629-6 6v1c0-3.31371 2.68629-6 6-6h52c3.3137 0 6 2.68629 6 6v-1c0-3.31371-2.6863-6-6-6z",
    fill: "#909592",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 44.5-21.4393-21.4393c-.945-.945-.2757-2.5607 1.0606-2.5607h20.3787z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 0 24 24h-18c-3.3137 0-6-2.6863-6-6z",
    fill: "#d7dcda"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.75 66.3633c1.0938 0 1.5938-.75 1.5938-1.75v-.5313c.0312-2.0625.7656-2.9219 3.2656-4.6406 2.6875-1.8125 4.3906-3.9063 4.3906-6.9219 0-4.6875-3.8125-7.375-8.5625-7.375-3.5313 0-6.625 1.6719-7.9531 4.6875-.3282.7344-.4688 1.4531-.4688 2.0469 0 .8906.5156 1.5156 1.4688 1.5156.7968 0 1.3281-.4687 1.5625-1.2344.7969-2.9687 2.7656-4.0937 5.2812-4.0937 3.0469 0 5.4375 1.7187 5.4375 4.4375 0 2.2344-1.3906 3.4844-3.3906 4.8906-2.4531 1.7031-4.25 3.5313-4.25 6.2813v.9843c0 1 .5469 1.7032 1.625 1.7032zm0 8.5468c1.25 0 2.2344-1 2.2344-2.2187 0-1.2344-.9844-2.2188-2.2344-2.2188-1.2188 0-2.2188.9844-2.2188 2.2188 0 1.2187 1 2.2187 2.2188 2.2187z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.260e66df105f977d520e7a3aecd90e3b.svg";
export { ForwardRef as ReactComponent };